// accionesBoton.js — Qué hace un botón configurado desde el admin.
//
// Lo comparten las secciones que dejan elegir la acción de un botón
// (`tarjeta_programa`, `tarjetas_curso`): abrir el formulario de solicitud de
// acceso, el acceso o el registro del proyecto, o ir a una dirección.
//
// Botón: { accion: 'url' | 'login' | 'registro' | 'solicitud' | 'ninguna',
//          url, nueva_pestana }. `crear_cuenta` abre el formulario de la portada
// como registro: la cuenta queda creada y con sesión al enviarlo.
import { abrirSolicitudAcceso } from './SolicitudAccesoSection';

export const ACCIONES_BOTON = [
  { value: 'url', label: 'Ir a una dirección' },
  { value: 'solicitud', label: 'Abrir el formulario de solicitud de acceso' },
  { value: 'login', label: 'Abrir el acceso (iniciar sesión)' },
  { value: 'registro', label: 'Abrir el registro' },
  { value: 'crear_cuenta', label: 'Abrir el formulario de la portada como registro (cuenta al instante)' },
];

export const crearActivador = ({ navigate, openLogin, openRegister }) => (boton) => {
  const b = boton || {};
  if (b.accion === 'ninguna') return undefined;
  if (b.accion === 'solicitud') return abrirSolicitudAcceso();
  if (b.accion === 'crear_cuenta') return abrirSolicitudAcceso({ modo: 'registro' });
  if (b.accion === 'login') return openLogin ? openLogin() : navigate('/login');
  if (b.accion === 'registro') return openRegister ? openRegister() : navigate('/register');
  if (!b.url) return undefined;
  if (/^https?:\/\//i.test(b.url)) {
    if (b.nueva_pestana !== false) window.open(b.url, '_blank', 'noopener');
    else window.location.href = b.url;
    return undefined;
  }
  return navigate(b.url);
};

export default crearActivador;
